<ng-container *ngIf="showSwitcher | async">
  <label for="clientSwitcher" class="fw-bold">{{ prompt }}</label>
  <select
    id="clientSwitcher"
    [ngModel]="chosenCompany | async"
    (ngModelChange)="switchCompany($event)"
    class="form-control">
    <option *ngFor="let company of companyData | async" [ngValue]="company.Id">
      <span *ngIf="company.DBA != null && company.DBA != ''">{{ company.DBA }}</span>
      <span *ngIf="company.DBA == null || company.DBA == ''">{{ company.Name }}</span>
    </option>
  </select>
</ng-container>
